import React, { FocusEvent } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes, CheckboxStates, RegexHelper } from "src/common";
import { Checkbox, Icon } from "src/components";

type AllProps = {
  address: string;
  selected: boolean;
  handleAction: ActionHandlerFunction;
};

// Description: ListRowComponent is a component that renders a row in a list view in the email gateway page.
function ListRowComponent(props: AllProps) {
  const { address, handleAction, selected } = props;

  return <Row>
    <Col md="1">
      <Checkbox
        className="sr-only"
        onChange={(e: FocusEvent<HTMLInputElement>) => { handleAction({ actionType: AdminUIActionTypes.Select, params: { selected: e.target.checked, address }});}}
        selected={selected ? CheckboxStates.checked : CheckboxStates.empty}
        value="all" label="Select All" />
    </Col>
    <Col md="5" className="col">
      <Icon className={`${RegexHelper.testEmailAddress(address) ? "ficon-user" : "ficon-globe"} me-1 text-muted`} />
      {address}
    </Col>
    <Col md="1" className={"ms-auto"} onClick={(e: React.MouseEvent<HTMLButtonElement>) => e.stopPropagation()}>
      <Button
        className="ms-auto"
        variant="icon"
        size="sm"
        onClick={() => handleAction({ actionType: AdminUIActionTypes.Delete, params: [address] })}
        aria-label="Delete Address or Domain"
      >
        <Icon className="ficon-x" />
      </Button>
    </Col>
  </Row>;
}

export default React.memo(ListRowComponent); 
